import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
export const selectReportTitles = ({ UserPerformancePage_reducer }) => {
    return UserPerformancePage_reducer.reportTypes;
};
export const selectUsers = ({ UserPerformancePage_reducer }) => {
    return UserPerformancePage_reducer.users;
};
export const selectMonth = ({ UserPerformancePage_reducer }) => {
    return UserPerformancePage_reducer.monthFilter;
};
export const selectYear = ({ UserPerformancePage_reducer }) => {
    return UserPerformancePage_reducer.yearFilter;
};
export const selectDateFilterType = ({ UserPerformancePage_reducer }) => {
    return UserPerformancePage_reducer.dateFilterType;
};
export const getRequesting = ({ UserPerformancePage_reducer }) => {
    return UserPerformancePage_reducer.requesting;
};
export const selectFilterUserUid = ({ UserPerformancePage_reducer }) => {
    return UserPerformancePage_reducer.userUid;
};
export const selectCurrentTable = ({ UserPerformancePage_reducer }) => {
    return UserPerformancePage_reducer.currentTable;
};
export const selectData = createSelector(
    [
        selectUsers,
        selectReportTitles,
        selectMonth,
        selectYear,
        selectDateFilterType,
    ],
    (
        users = false,
        reportTypes = false,
        fMonth = false,
        fYear = false,
        filterType
    ) => {
        if (users && reportTypes) {
            return Object.keys(reportTypes).map((report_type_key) => {
                let user_data = getFormattedReportData(
                    users,
                    report_type_key,
                    fMonth,
                    fYear,
                    filterType
                );

                let data = {
                    labels: user_data.names,
                    datasets: [
                        {
                            label: `Report User Totals`,
                            data: user_data.reports,
                            backgroundColor: "#0188cc",
                            borderColor: "rgba(63,81,181,1)",
                            borderWidth: 0,
                            borderRadius: 4,
                            hoverBackgroundColor: "#0188cc",
                            hoverBorderColor: "rgba(63,81,181,1)",
                        },
                    ],
                };
                return { title: reportTypes[report_type_key], data };
            });
        } else return false;
    }
);
const getFormattedReportData = (
    users,
    report_type_key,
    fMonth,
    fYear,
    filterType
) => {
    let names = [],
        reports = [];
    Object.keys(users).map((user_index) => {
        let fname = _.get(users[user_index], "profile.first_name") || "N/A";
        let lname = _.get(users[user_index], "profile.last_name") || "N/A";
        let report = _.get(users[user_index], `receipts`) || {};

        let reps = [];
        Object.keys(report).map((e) => {
            Object.keys(report[e]).map((f) => {
                let rep = _.get(report[e][f], report_type_key) || false;
                if (rep)
                    Object.keys(rep).map((x) => {
                        reps.push(rep[x]);
                        return null;
                    });
                return null;
            });
            return null;
        });
        if (filterType) {
            reps = filterByDate(reps, fMonth, fYear, filterType);
        }
        if (!_.get(users[user_index], "profile.deleted")) {
            reports.push(reps.length);
            names.push(`${fname} ${lname[0]}`);
        }

        return true;
    });
    return { names, reports };
};
const filterByDate = (Reports, month, year, type) => {
    return _.filter(Reports, (f) => {
        if (type === "month") {
            let rMonth = Number(
                moment(f.timestamp, "DD-MM-YYYY HH:mm:ss").month()
            );
            let rYear = Number(
                moment(f.timestamp, "DD-MM-YYYY HH:mm:ss").format("YYYY")
            );

            if (rMonth === Number(month) && rYear === Number(year)) {
                return true;
            } else return false;
        } else if (type === "year") {
            let rYear = Number(
                moment(f.timestamp, "DD-MM-YYYY HH:mm:ss").format("YYYY")
            );

            if (rYear === Number(year)) {
                return true;
            } else return false;
        } else return false;
    });
};
export const selectRegisteredUsers = createSelector([selectUsers], (users) => {
    if (users === false || typeof users === "undefined" || users === null) {
        return [];
    }
    let regUsers = Object.keys(users).map((e) => {
        return {
            name: `${_.get(users[e], "profile.first_name")} ${_.get(
                users[e],
                "profile.last_name"
            )}`,
            uid: _.get(users[e], "profile.uid"),
            deleted: _.get(users[e], "profile.deleted"),
        };
    });
    regUsers = regUsers.filter((e) => {
        if (e.deleted !== true) {
            return true;
        } else {
            return false;
        }
    });
    return regUsers.sort((a, b) => a.name.localeCompare(b.name));
});
export const selectUserReportsData = createSelector(
    [selectUsers, selectReportTitles, selectFilterUserUid],
    (users = false, reportTypes = false, userUid) => {
        if (users && reportTypes && userUid) {
            return userUid.map((user_key) => {
                let user_data = getFormattedUserReportData(
                    users,
                    user_key,
                    reportTypes
                );
                return user_data;
            });
        } else return false;
    }
);
const getFormattedUserReportData = (users, user_key, reportTypes) => {
    let reports = {};
    let fname = _.get(users[user_key], "profile.first_name") || "N/A";
    let lname = _.get(users[user_key], "profile.last_name") || "N/A";
    let recipts = _.get(users[user_key], "receipts") || {};
    let report = {};
    //using loop insted of complete loadsh function
    Object.keys(reportTypes).map((report_type_key) => {
        let count = 0;
        Object.keys(recipts).map((k) => {
            var year_wise_recipts = recipts[k];
            Object.keys(year_wise_recipts).map((j) => {
                let length = 0;
                report[j] = _.get(year_wise_recipts[j], report_type_key);
                if (typeof report[j] !== "undefined" && report[j] !== null) {
                    length = Object.keys(report[j]).length;
                    count = count + length;
                    return null;
                }
                return null;
            });
            return null;
        });
        reports[report_type_key] = count;
        return null;
    });

    // Object.keys(reportTypes).map(report_type_key => {
    //     let report = _.get(users[user_key], `reports.${report_type_key}`) || {};
    //     if (_.get(users[user_key], "profile.deleted") === false) {
    //         reports[report_type_key] = Object.keys(report).length;
    //     }
    //     return true;
    // });
    return { names: fname + " " + lname, ...reports };
};
